export const calculateMoneysureQuery = `mutation calculate($input: CalculateInput!){
    calculate(input: $input){
        comparatorCalculationResult {
            policyPolicyDetails {
                refKey
                orderFormId
                productCode
                customProperties {
                  supplierKrn
                }
                moneySurePremiumResponses {
                    origin
                    currency
                    moneySurePremiums {
                        tariff
                        yearlyGrossPremium
                        monthlyGrossPremium
                        moneySureInsuredPremiums {
                            birthDate
                            premium
                        }
                    }
                }
            }
            commonTechnical {
                transactionReference
                accessCode
            }
        }
    }
}`;

export const recalculateMoneysureQuery = `mutation ReCalculate($input: CalculateInput!){
    calculate(input: $input){
        comparatorCalculationResult {
            commonTechnical {
                transactionReference
                sessionId
            }
            policyPolicyDetails {
                customProperties {
                    supplierKrn
                }
                conditionConditionDetails {
                    conditionNumber
                    conditionText
                    documents {
                        attachmentDescription
                        attachmentType
                        urlAttachment
                    }
                }
                coverageMedicalExpenses {
                    coverageDescription
                    sumInsured
                }
                documents {
                    urlAttachment
                    attachmentType
                    attachmentDescription
                }
                orderFormId
                productCode
                renewalCommissionInstallmentAmount
                productDescription
                paymentTermInMonths
                porCompany
                companyNameDescription
                marketingName
                netPremiumInstallment
                costsInstallmentAmount
                insuranceTaxInstallmentAmount
                totalInstallmentAmount
                grossPremiumInstallment
                surchargesInstallmentAmount
                discountsInstallmentAmount
                underwritingCompanySpecifics{
                    rejectionReason
                }
                effectiveDate
                refKey
            }
        }
    }
}`;
